const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * Dado de cliente (nome, e-mail, modelo…) dentro de texto que vai para `[innerHtml]` — o modal de
 * confirmação e o toast renderizam HTML. O sanitizador do Angular tira script, mas deixa `<b>`,
 * `<img>` e afins: um nome "<b>R$ 0,00</b>" mudaria o que o admin lê antes de confirmar dinheiro.
 */
export function escapeHtml(value: unknown): string {
  return String(value ?? '').replace(/[&<>"']/g, char => HTML_ESCAPES[char]);
}
